export const LOAD_PREFERRED_SITE_LIST =
  'preferred_site/LOAD_PREFERRED_SITE_LIST';
export const LOAD_PREFERRED_SITE_LIST_SUCCESS =
  'preferred_site/LOAD_PREFERRED_SITE_LIST_SUCCESS';
export const LOAD_PREFERRED_SITE_LIST_ERROR =
  'preferred_site/LOAD_PREFERRED_SITE_LIST_ERROR';
